export default __webpack_public_path__ + "static/media/uae.359cde04.jpg";